import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API } from '@const'
import * as utils from '@utils'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Divider from '@material-ui/core/Divider'

const initialState = {
    input: {
        account: '',
        password: '',
        name: '',
        role_id: 0,
        pf_id: '',
    },
    dialogOpen: false,
    roleList: []
}

class EditUserDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'EditUserDialog')
        }
        this.state = initialState
    }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    reset(inputs) {
        const roleList = utils.convertSort({ source: this.props.roleList, replaceText: true })
                            .filter(item => {
                                let isEnable = true
                                if (inputs.role_id !== inputs.root_role_id) {
                                    isEnable = item.id !== item.root_role_id
                                }
                                return isEnable
                            })

        this.setState({
            input: {
                ...inputs,
            },
            roleList,
        })
    }

    OpenDialog(inputs) {
        this.reset(inputs)
        this.setState({ 
            dialogOpen: true
        })
    }

    closeDialog() {
        this.setState({ dialogOpen: false })
    }

    confirm() {
        if (this.props.confirmCallback) {
            this.props.confirmCallback()
        }
        this.closeDialog()
    }

    render() {
        const { auth } = this.props 
        return (
            <Dialog open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })}>
                <DialogTitle>{this.t('Title')}</DialogTitle>
                <DialogContent>
                    <TextField
                        disabled
                        label={this.t('account')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={this.state.input.account}
                        onChange={(event) =>
                            this.setState({
                                input: {
                                    ...this.state.input,
                                    account: event.target.value,
                                },
                            })
                        }
                        margin="dense"
                        fullWidth
                    />
                    <TextField
                        type="password"
                        label={this.t('password')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={this.state.input.password}
                        onChange={(event) => {
                            /** 去除空白輸入 */
                            const password = event.target.value
                            this.setState({
                                input: {
                                    ...this.state.input,
                                    password: password.replace(/\s*/g,""),
                                },
                            })
                        }}
                        margin="dense"
                        fullWidth
                    />
                    <div className={this.props.classes.passwordFormat}>{this.t('passwordFormatError')}</div>
                    <TextField
                        label={this.t('name')}
                        InputLabelProps={{
                            shrink: true,
                        }}
                        value={this.state.input.name}
                        onChange={(event) =>
                            this.setState({
                                input: {
                                    ...this.state.input,
                                    name: event.target.value,
                                },
                            })
                        }
                        margin="dense"
                        fullWidth
                    />
                    <FormControl margin="dense" fullWidth>
                        <InputLabel htmlFor="role_id">{this.t('role')}</InputLabel>
                        <Select
                            value={this.state.input.role_id}
                            onChange={(event) =>
                                this.setState({
                                    input: {
                                        ...this.state.input,
                                        role_id: event.target.value,
                                    },
                                })
                            }
                            disabled={!auth.isSuperUser && !auth.isAdmin && this.state.input.role_id === this.state.input.root_role_id}>
                            {this.state.roleList.map((item)=>(
                                <MenuItem value={item.id} key={item.id}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => {
                            /** 密碼去除空白 */
                            const password = this.state.input.password ? this.state.input.password.replace(/\s*/g,"") : ''
                            /** 有輸入密碼時驗證格式
                             *  編輯使用者時密碼欄位可留空(不更改密碼)
                             */
                            if (password && !utils.passwordFormat(this.state.input.password)) {
                                utils.addToast(this.t('passwordFormatError'), 'error')
                                return
                            }
                            utils.apiRequest(
                                'put',
                                API.USER,
                                {
                                    ...this.state.input,
                                    role_id: parseInt(this.state.input.role_id),
                                },
                                (_data) => {
                                    this.confirm()
                                }
                            )
                        }}
                        color="primary">
                        {this.t('confirm')}
                    </Button>
                    <Button variant="contained" onClick={() => this.closeDialog()} color="secondary">
                        {this.t('cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (_theme) => {
    return {
        editorToolbar: {
            border: 'solid 1px',
            margin: '12px 0',
            borderColor: 'rgba(0, 0, 0, 0.3)',
        },
        editorWrapper: {},
        editorEditor: {
            height: '300px',
            padding: '0 14px',
            border: 'solid 1px',
            borderColor: 'rgba(0, 0, 0, 0.3)',
        },
        passwordFormat: {
            fontSize: '12px',
            color: '#69131c',
            paddingBottom: '10px',
        },
    }
}

EditUserDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
    roleList: PropTypes.object,
    auth: PropTypes.object,
}

export default hoc(styles)(EditUserDialog)
